import { render, staticRenderFns } from "./Jewel02.vue?vue&type=template&id=60fb4236&scoped=true&"
import script from "./Jewel02.vue?vue&type=script&lang=js&"
export * from "./Jewel02.vue?vue&type=script&lang=js&"
import style0 from "./Jewel02.vue?vue&type=style&index=0&id=60fb4236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb4236",
  null
  
)

export default component.exports